import { ClockCountdownIcon } from "@phosphor-icons/react";

import type { SafetyMeetingLiveAttendanceMeetingSnapshot } from "@miter/types/common";

export const ClosedScreen = ({
  snapshot,
}: {
  snapshot: SafetyMeetingLiveAttendanceMeetingSnapshot;
}): React.JSX.Element => (
  <div className="tw:flex tw:flex-1 tw:flex-col tw:items-center tw:justify-center tw:gap-4 tw:p-6 tw:text-center">
    <ClockCountdownIcon size={48} className="tw:text-midnight/30" />
    <h1 className="tw:m-0 tw:text-2xl tw:font-denim tw:text-midnight">Sign-in has closed</h1>
    <div className="tw:max-w-90 tw:text-sm tw:text-midnight/70">
      The sign-in window for {snapshot.meeting_name} is closed.
    </div>
    <div className="tw:max-w-90 tw:text-sm tw:text-midnight/60">
      If you were at the meeting, {snapshot.supervisor_name ?? "your supervisor"} can add you by hand.
    </div>
  </div>
);
